// extracted by mini-css-extract-plugin
export default {"rippler":"TinyRippler_rippler__xFWlk","show":"TinyRippler_show__Gc1iS","ldsripple":"TinyRippler_ldsripple__qSU-D"};